import { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { useEditorStore } from '../../store/editorStore';

export default function CTAProperties({ layer }) {
  const data = layer.data;
  const updateLayerData = useEditorStore((s) => s.updateLayerData);
  const [bgOpen, setBgOpen] = useState(false);
  const [textColorOpen, setTextColorOpen] = useState(false);

  function update(updates) {
    updateLayerData(layer.id, updates);
  }

  function updateStyle(updates) {
    update({ style: { ...data.style, ...updates } });
  }

  return (
    <div className="p-2 space-y-3">
      <p className="panel-label">CTA Button</p>

      <div>
        <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Button Text</label>
        <input
          type="text" value={data.text}
          onChange={(e) => update({ text: e.target.value })}
          className="input-field text-xs"
          placeholder="Learn More"
        />
      </div>

      <div>
        <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>URL</label>
        <input
          type="url" value={data.url}
          onChange={(e) => update({ url: e.target.value })}
          className="input-field text-xs"
          placeholder="https://..."
        />
      </div>

      <label className="flex items-center gap-2">
        <input
          type="checkbox" checked={data.openInNewTab}
          onChange={(e) => update({ openInNewTab: e.target.checked })}
          className="rounded"
        />
        <span className="text-xs" style={{ color: 'var(--t-muted)' }}>Open in new tab</span>
      </label>

      <div className="grid grid-cols-2 gap-1.5">
        <div>
          <label className="text-xs block mb-1" style={{ color: 'var(--t-muted)' }}>Background</label>
          <div className="flex items-center gap-1">
            <div className="w-6 h-6 rounded cursor-pointer"
                 style={{ border: '1px solid var(--t-border2)', background: data.style.backgroundColor }}
                 onClick={() => setBgOpen(!bgOpen)} />
            <input type="text" value={data.style.backgroundColor}
                   onChange={(e) => updateStyle({ backgroundColor: e.target.value })}
                   className="input-field text-xs py-1 font-mono flex-1 min-w-0" />
          </div>
          {bgOpen && (
            <div className="mt-1">
              <HexColorPicker color={data.style.backgroundColor}
                              onChange={(c) => updateStyle({ backgroundColor: c })}
                              style={{ width: '100%', height: 100 }} />
            </div>
          )}
        </div>
        <div>
          <label className="text-xs block mb-1" style={{ color: 'var(--t-muted)' }}>Text Color</label>
          <div className="flex items-center gap-1">
            <div className="w-6 h-6 rounded cursor-pointer"
                 style={{ border: '1px solid var(--t-border2)', background: data.style.color }}
                 onClick={() => setTextColorOpen(!textColorOpen)} />
            <input type="text" value={data.style.color}
                   onChange={(e) => updateStyle({ color: e.target.value })}
                   className="input-field text-xs py-1 font-mono flex-1 min-w-0" />
          </div>
          {textColorOpen && (
            <div className="mt-1">
              <HexColorPicker color={data.style.color}
                              onChange={(c) => updateStyle({ color: c })}
                              style={{ width: '100%', height: 100 }} />
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-1.5">
        <div>
          <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Font Size</label>
          <input type="number" value={data.style.fontSize}
                 onChange={(e) => updateStyle({ fontSize: parseInt(e.target.value) || 16 })}
                 min={10} max={48} className="input-field text-xs py-1" />
        </div>
        <div>
          <label className="text-xs block mb-0.5" style={{ color: 'var(--t-muted)' }}>Border Radius</label>
          <input type="number" value={data.style.borderRadius}
                 onChange={(e) => updateStyle({ borderRadius: parseInt(e.target.value) || 0 })}
                 min={0} max={100} className="input-field text-xs py-1" />
        </div>
      </div>

      <div>
        <p className="text-xs mb-1" style={{ color: 'var(--t-muted)' }}>UTM Parameters (optional)</p>
        <div className="space-y-1.5">
          {['source', 'medium', 'campaign', 'content'].map((param) => (
            <input
              key={param}
              type="text"
              value={data.utmParams?.[param] || ''}
              onChange={(e) => update({
                utmParams: { ...(data.utmParams || {}), [param]: e.target.value },
              })}
              className="input-field text-xs"
              placeholder={`utm_${param}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
